import firebase from 'firebase';
const firebaseConfig = {
    apiKey: "AIzaSyDam7pP2UY-b9yspf3QWaPXEx66b2DTGPY",
    authDomain: "androbi-9e8e3.firebaseapp.com",
    databaseURL: "https://androbi-9e8e3.firebaseio.com",
    projectId: "androbi-9e8e3",
    storageBucket: "androbi-9e8e3.appspot.com",
    messagingSenderId: "375855593515",
    appId: "1:375855593515:web:2a709470119899a930526e",
    measurementId: "G-XX3K86ET96"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
// const firebaseAnalytics = firebase.analytics();


export default firebaseApp.firestore();
